import { render, staticRenderFns } from "./ParagraphImageText.vue?vue&type=template&id=8e629ff6&scoped=true&"
import script from "./ParagraphImageText.vue?vue&type=script&lang=js&"
export * from "./ParagraphImageText.vue?vue&type=script&lang=js&"
import style0 from "./ParagraphImageText.vue?vue&type=style&index=0&id=8e629ff6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e629ff6",
  null
  
)

export default component.exports